import { ExternalLink } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { TRIAL } from '@/constants/testIds/healthspan';

function statusStyle(status) {
  const s = (status || '').toLowerCase();
  if (s.includes('recruiting')) return 'text-[color:var(--success)] border-[color:rgba(46,139,87,0.35)] bg-[color:rgba(46,139,87,0.10)]';
  if (s.includes('active')) return 'text-[color:var(--accent-teal)] border-[color:rgba(0,166,166,0.35)] bg-[color:rgba(0,166,166,0.10)]';
  if (s.includes('completed')) return 'text-[color:var(--muted-fg)] border-[color:var(--border-color)] bg-[color:var(--surface-2)]';
  if (s.includes('withdrawn') || s.includes('terminated')) return 'text-[color:var(--warning)] border-[color:rgba(216,155,0,0.35)] bg-[color:rgba(216,155,0,0.10)]';
  return 'text-[color:var(--muted-fg)] border-[color:var(--border-color)] bg-[color:var(--surface-2)]';
}

export default function TrialCard({ trial }) {
  return (
    <Card data-testid={TRIAL.card} className="rounded-[var(--radius-md)] border border-[color:var(--border-color)] bg-[color:var(--surface)] p-4 sm:p-5 shadow-[var(--shadow-sm)]">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-wider text-[color:var(--muted-fg)]">{trial.nct_id}</div>
          <h3 className="mt-1 text-sm font-semibold leading-snug">{trial.title}</h3>
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2 text-[11px]">
        {trial.status && <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 ${statusStyle(trial.status)}`}>{trial.status}</span>}
        {trial.phase && <span className="inline-flex items-center rounded-full border border-[color:var(--border-color)] bg-[color:var(--surface-2)] text-[color:var(--muted-fg)] px-2.5 py-0.5">{trial.phase}</span>}
      </div>
      {trial.conditions?.length ? (
        <div className="mt-3 text-xs text-[color:var(--muted-fg)]"><span className="font-medium">Conditions:</span> {trial.conditions.slice(0, 3).join(', ')}</div>
      ) : null}
      {trial.interventions?.length ? (
        <div className="mt-1 text-xs text-[color:var(--muted-fg)]"><span className="font-medium">Interventions:</span> {trial.interventions.slice(0, 3).join(', ')}</div>
      ) : null}
      {trial.brief_summary && (
        <p className="mt-3 text-sm leading-6 text-[color:var(--muted-fg)] line-clamp-4">{trial.brief_summary}</p>
      )}
      <div className="mt-4 pt-3 border-t border-[color:var(--border-color)]">
        <a data-testid={TRIAL.link} href={trial.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm text-[color:var(--accent-teal)] underline underline-offset-4 hover:no-underline">View on clinicaltrials.gov <ExternalLink className="h-3.5 w-3.5" /></a>
      </div>
    </Card>
  );
}
